import { fadeIn, fadeOut } from "@/utils/utils"

export default class BasePopup {
	#id

	constructor(id) {
		this.#id = id
		this.#basePopupInit()
	}

	get id() {
		return this.#id
	}

	#getBasePopupTemplate() {
		return `
        <div id="${this.#id}" class="popup-wrapper position-fixed justify-content-center align-items-start mx-5"
            style="display: none;">
            <div class="popup container px-0 px-md-2">
                <div class="popup-content container px-0 px-md-2 mb-md-5"></div>
            </div>
        </div>
    `
	}

	#injectBasePopupHTML() {

		const existing = document.querySelector(`#${this.#id}`)
		if (existing) existing.remove()

		const container = document.querySelector("#popupContainer")
		if (container) {
			container.insertAdjacentHTML("beforeend", this.#getBasePopupTemplate())
		} else {
			document.body.insertAdjacentHTML("beforeend", this.#getBasePopupTemplate())
		}
	}

	#setBasePopupListeners() {
		this.getOverlay()?.addEventListener("click", () => this.hide())
	}

	#basePopupInit() {
		this.#injectBasePopupHTML()
		this.#setBasePopupListeners()
	}

	getOverlay() {
            let overlay = document.querySelector("#tf-overlay");
            if (!overlay) {
                overlay = document.createElement("div");
                overlay.id = "tf-overlay";
                overlay.classList.add("popup-overlay");
                document.body.appendChild(overlay);
            }
            return overlay;
	}

	getRootDiv() {
		return document.querySelector(`#${this.#id}`)
	}

	getPopupContentDiv() {
		return this.getRootDiv()?.querySelector(".popup-content")
	}

	injectContentHTML(html) {
		const popupContent = this.getPopupContentDiv()
		if (!popupContent) {
			return
		}
		popupContent.innerHTML = ""
		popupContent.insertAdjacentHTML("beforeend", html)
	}

	display(e) {
		e?.preventDefault()
		document.body.classList.add("overflow-hidden")
		fadeIn(this.getOverlay(), "block")
		fadeIn(this.getRootDiv(), "block")
	}

	hide() {
		document.body.classList.remove("overflow-hidden")
		fadeOut(this.getOverlay())
		fadeOut(this.getRootDiv())
	}
}
